import {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash"
import {Empty, Modal, notification} from "antd";
import
{
	Button,
	Loading,
	Icon
} from "~/components";
import ActionBar from "~/layout/ActionBar";
import
{
	handleRequest,
	apiError,
} from "~/utils";
import
{
	useCan
} from "~/hooks";
import
{
	productCategoryApi
} from "~/api";
import {
	ProductCategorySearchBar,
	ProductCategoryTable,
	ProductCategoryFormAddEdit,
} from "../components";
import {
	productCategoryActions,
	productCategoryFilterSelector,
	productCategoryItemsSelector,
	productCategoryLoadingSelector,
	productCategoryPaginationSelector
} from "../../../reduxs/ProductCategory/productCategorySlice";


function ProductCategory()
{
	const can = {
	    add : useCan('products_categories_add'),
	    edit : useCan('products_categories_edit'),
	    delete : useCan('products_categories_delete')
	}

	const dispatch  = useDispatch();

	const items     = useSelector(productCategoryItemsSelector);

	const loading   = useSelector(productCategoryLoadingSelector);

	const pagination = useSelector(productCategoryPaginationSelector);

	const filter    = useSelector(productCategoryFilterSelector);

	const [itemEdit, setItemEdit] = useState({});
	const [reloadKey, setReloadKey] = useState(0);

	//Model
	const [openModal, setOpenModal] = useState({
		addEdit     : false,
		delete      : false,
	});

	const eventHandlers =
	{
		openModal : useCallback((modal) =>
		{
			setOpenModal(prev => ({ ...prev, [modal]: true }));
			if(modal === 'addEdit') {
				setReloadKey(prev => prev + 1);
			}
		}, []),

		closeModal : useCallback((modal) =>
		{
			setOpenModal(prev => ({ ...prev, [modal]: false }));
		}, []),

		load: useCallback(() =>
		{
			dispatch(productCategoryActions.fetchData(filter));
		}, [dispatch, filter]),

		paginationChange: (page) =>
		{
			dispatch(productCategoryActions.setFilter({...filter, page }));
		},

		search: (newFilter) =>
		{
			dispatch(productCategoryActions.setFilterWithDebounce(newFilter));
		},

		filterChange: (key, value) =>
		{
			const newFilter = {
				...filter,
				[key]: value,
				page: 1
			};
			dispatch(productCategoryActions.setFilter(newFilter));
		},

		add: async (data) =>
		{
			let [error, response] = await handleRequest(productCategoryApi.add(data));

			let message = apiError(`Thêm danh mục thất bại`, error, response);

			if(!message)
			{
				notification.success({message: 'Thành công', description: `Thêm danh mục thành công`});

				dispatch(productCategoryActions.add(response.data));

				setReloadKey(prev => prev + 1);

				eventHandlers.closeModal('addEdit')
			}
		},

		edit: async (item) =>
		{
			if (!item?.id)
			{
				notification.error({message: 'Lỗi', description: 'Không có thông tin danh mục để cập nhật'});
				return;
			}

			setItemEdit(item);

			let [error, response] = await handleRequest(productCategoryApi.get(item.id));

			if(!apiError(`Lấy thông tin danh mục thất bại`, error, response))
			{
				setItemEdit(response.data);
				eventHandlers.openModal('addEdit');
			}
		},

		update: async (data, item) =>
		{
			if (!item?.id)
			{
				notification.error({message: 'Lỗi', description: 'Không có thông tin danh mục để cập nhật'});
				return;
			}

			data.id = item.id;

			let [error, response] = await handleRequest(productCategoryApi.update(data));

			if(!apiError(`Cập nhật thông tin danh mục thất bại`, error, response))
			{
				notification.success({message: 'Thành công', description: `Cập nhật thông tin danh mục thành công`});

				dispatch(productCategoryActions.update({
					...item,
					...response.data
				}));

				setReloadKey(prev => prev + 1);

				eventHandlers.closeModal('addEdit')
			}
		},

		deleteConfirm: (item) =>
		{
			setItemEdit(item);
			eventHandlers.openModal('delete');
		},

		//Delete
		delete: async () =>
		{
			if (!itemEdit?.id)
			{
				notification.error({message: 'Lỗi', description: 'Không có thông tin danh mục để xóa'});
				return;
			}

			let [error, response] = await handleRequest(productCategoryApi.delete(itemEdit.id));

			if(!apiError(`xóa danh mục thất bại`, error, response))
			{
				notification.success({message: 'Thành công', description: `xóa danh mục thành công`});

				dispatch(productCategoryActions.delete(itemEdit.id));

				eventHandlers.closeModal('delete')
			}
		}
	}

	//Load data
	useEffect(() =>
	{
		let isMounted = true;
		if (isMounted) eventHandlers.load();
		return () => { isMounted = false };
	}, [filter]);

	return (
		<>
			<ActionBar title={'Danh mục sản phẩm'}>
				{can.add && <Button outline leftIcon={Icon.plusCircle} onClick={() => {setItemEdit({}); eventHandlers.openModal('addEdit')}}>Thêm mới</Button>}
				<Button outline onClick={eventHandlers.load}>{Icon.reload}</Button>
			</ActionBar>
			<div className="container">
				<div className="content p-2">
					{loading && <Loading/>}
					{<ProductCategorySearchBar filter={filter} onSearchChange={eventHandlers.search} onChange={eventHandlers.filterChange} can={can} />}
					{_.isEmpty(items) && <Empty />}
					{!_.isEmpty(items) && <ProductCategoryTable
							items={items}
							pagination={pagination}
							onPaginationChange={eventHandlers.paginationChange}
							onEdit={eventHandlers.edit}
							onDelete={eventHandlers.deleteConfirm}
							can={can}
					/>}
				</div>
				{
					(can.add || can.edit) && <Modal
						title="Danh mục sản phẩm"
						centered
						width={1000}
						open={openModal.addEdit}
						onCancel={() => {eventHandlers.closeModal('addEdit')}}
						footer={null}
					>
					<ProductCategoryFormAddEdit item={itemEdit}
											 onAdd={eventHandlers.add}
											 onUpdate={eventHandlers.update}
											 reloadKey={reloadKey}
					/>
					</Modal>
				}
				{
					(can.delete && itemEdit?.id) && <Modal
						title="Xóa danh mục"
						open={openModal.delete}
						onOk={eventHandlers.delete}
						okType={'danger'}
						onCancel={() => {eventHandlers.closeModal('delete')}}
					>
						<p>Bạn muốn xóa danh mục <b>{itemEdit?.name}</b>?</p>
					</Modal>
				}
			</div>
		</>
	)
}

export default ProductCategory;
